import { reducer as FormReducer } from 'redux-form';
import { i18nReducer } from 'react-redux-i18n';
import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import UsersReducer from './users_reducer';
import ProductsReducer from './products_reducer';
import CustomersReducer from './customers_reducer';
import PaymentTermsReducer from './paymentTerms_reducer';
import VendorsReducer from './vendors_reducer';
import AgentsReducer from './agents_reducer';

import PurchaseQuotesReducer from './purchaseQuotes_reducer';
import PurchaseSchedulesReducer from './purchaseSchedules_reducer';
import PurchaseTemplatesReducer from './purchaseTemplates_reducer';
import PurchaseReturnsReducer from './purchaseReturns_reducer';
import PurchaseOrdersReducer from './purchaseOrders_reducer';

import InventoriesReducer from './inventories_reducer';
import InventoryRelocationsReducer from './inventoryRelocations_reducer';
import InventoryAdjustmentsReducer from './inventoryAdjustments_reducer';
import InventoryRepackagesReducer from './inventoryRepackages_reducer';
import InventoryConvertsReducer from './inventoryConverts_reducer';
import ScrapRecordsReducer from './scrapRecords_reducer';
import PutAwayReducer from './putAway_reducer';
import ReceiveReducer from './receive_reducer';
import WarehousesReducer from './warehouses_reducer';
import ZonesReducer from './zones_reducer';

import SalesOrdersReducer from './salesOrders_reducer';
import WholesaleReducer from './wholesale_reducer';
import FavoriteListReducer from './favoriteList_reducer';
import GroupListReducer from './groupList_reducer';
import SalesInvoiceReducer from './salesInvoice_reducer';
import SalesInvoicePaymentReducer from './salesInvoicePayment_reducer';
import WholesaleModal from './wholesaleModal_reducer';
import DispatchReducer from './dispatch_reducer';

import FavoritesReducer from './favorites_reducer';
import PreviousOrdersReducer from './previousOrders_reducer';
import PromotionsReducer from './promotions_reducer';

import ARAPReducer from './arap_reducer';
import SettingsReducer from './settings_reducer';
import DashboardReducer from './dashboard_reducer';
import AuthReducer from './auth_reducer';
import PosReducer from './pos_reducer';
import PrintReducer from './print_reducer';
import AutoSuggestReducer from './autoSuggest_reducer';
import MobileManagementReducer from './mobileManagement_reducer';
import AdjustmentInventoryReducer from "./adjustmentInventory_reducer";
import RMAReducer from "./rma_reducers";
import MMDrivers from './mmdriver-reducer';
import TrackingReducer from './tracking_reducer';
import HeaderReducer from './headerRedux';

import CategoryAnalysisReducer from './categoryAnalysis_reducer';
import baseModals from './baseModals_reducers';
import MarketReducer from './market_reducer';

import { SalesAutoSuggestEpic, PurchaseAutoSuggestEpic } from '../actions/autoSuggest_actions';
import { PurchaseOrderListEpic } from '../actions/purchaseOrderList_actions';
import { SalesOrderListEpic, SalesQuoteListEpic } from '../actions/salesOrderList_actions';
import { SalesPerformanceListEpic } from '../actions/salesPerformanceList_actions';
import { PurchasingPerformanceListEpic } from '../actions/purchasingPerformanceList_actions';
import { PurchasingPerformanceListEpicGFD } from '../actions/purchasingPerformanceList_actions';
import { companySelectEpic } from './headerRedux';

export const rootEpic = combineEpics(
  SalesAutoSuggestEpic,
  SalesOrderListEpic,
  SalesQuoteListEpic,
  PurchaseAutoSuggestEpic,
  // ProductAutoSuggestEpic,
  PurchaseOrderListEpic,
  PurchasingPerformanceListEpic,
  PurchasingPerformanceListEpicGFD,
  SalesPerformanceListEpic,
  companySelectEpic,
);

const rootReducer = combineReducers({
  // Dashboard
  favorites: FavoritesReducer,

  // Ch 2
  users: UsersReducer,
  products: ProductsReducer,
  customers: CustomersReducer,
  paymentTerms: PaymentTermsReducer,
  form: FormReducer,
  vendors: VendorsReducer,
  agents: AgentsReducer,
  auth: AuthReducer,

  // Ch 3
  purchaseQuotes: PurchaseQuotesReducer,
  purchaseTemplates: PurchaseTemplatesReducer,
  purchaseSchedules: PurchaseSchedulesReducer,
  purchaseReturns: PurchaseReturnsReducer,
  purchaseOrders: PurchaseOrdersReducer,
  trackingNote: TrackingReducer,

  // Ch 4
  salesOrders: SalesOrdersReducer,
  previousOrders: PreviousOrdersReducer,
  promotions: PromotionsReducer,
  wholesale: WholesaleReducer,
  customerFavorites: FavoriteListReducer,
  customerGroups: GroupListReducer,
  salesInvoice: SalesInvoiceReducer,
  salesInvoicePayment: SalesInvoicePaymentReducer,
  wholesaleModal: WholesaleModal,
  pos: PosReducer,

  // Ch 5
  inventories: InventoriesReducer,
  inventoryRelocations: InventoryRelocationsReducer,
  inventoryAdjustments: InventoryAdjustmentsReducer,
  inventoryRepackages: InventoryRepackagesReducer,
  inventoryConverts: InventoryConvertsReducer,
  scrapRecords: ScrapRecordsReducer,
  putAway: PutAwayReducer,
  receives: ReceiveReducer,
  warehouses: WarehousesReducer,
  zones: ZonesReducer,

  categoryAnalysis: CategoryAnalysisReducer,

  // Ch 6
  dispatch: DispatchReducer,

  arap: ARAPReducer,
  settings: SettingsReducer,
  dashboard: DashboardReducer,
  print: PrintReducer,
  autoSuggest: AutoSuggestReducer,
  mobileManagement: MobileManagementReducer,
  adjustment: AdjustmentInventoryReducer,

  rma: RMAReducer,
  i18n: i18nReducer,

  MMDrivers,
  baseModals,

  header: HeaderReducer,
  market: MarketReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./master/jsx/reducers/index.js